import {Component, Injector, OnInit} from '@angular/core';
import {Funcao} from "../../../../domain/enums";
import {Pessoa} from "../../../../domain/Pessoa";
import {PessoaComponent} from "../edit/pessoa.component";
import {AbstractListOrmComponent} from "../../AbstractListOrmComponent";
import LocalDataSource from "../../../../data-sources/LocalDataSource";
import {FaunaDataSource} from "../../../../services/persist/FaunaDataSource";
import {TableLazyLoadEvent} from "primeng/table";
import {FindManyOptions} from "typeorm";

@Component({
  selector: 'app-list-pessoa',
  templateUrl: './list-pessoa.component.html',
  styleUrls: ['./list-pessoa.component.scss'],
})
export class ListPessoaComponent extends AbstractListOrmComponent<Pessoa>{
  funcoes = Object.values(Funcao)
  select = ['id','nome','email','funcoes']
  agenciavel = true

  constructor(injector: Injector, ds: FaunaDataSource) {
    super(injector, ds.getRepository(Pessoa))
  }
}
